<script setup lang="ts">
import { PhWifiSlash } from "@phosphor-icons/vue";
import { useOnline } from "@vueuse/core";

const online = useOnline();
</script>

<template>
  <div aria-live="polite" class="offline-region">
    <p v-if="!online" class="offline">
      <PhWifiSlash :size="18" aria-hidden="true" />
      <span>Sin conexión. Verás los cambios cuando vuelvas a estar en línea.</span>
    </p>
  </div>
</template>

<style scoped>
.offline {
  max-width: var(--page-max);
  margin: 0 auto;
  display: flex;
  gap: 8px;
  align-items: center;
  padding: 8px var(--page-gutter);
  font-size: 13px;
  color: var(--color-accent-2-800);
  background: var(--color-accent-2-100);
}
</style>
